<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="save">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span class="text-h5">{{ header }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>
      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>
      <v-card-text>
        <v-container>
          <v-row style="display: block; margin-left: 12%; margin-right: 12%">
            <v-card outlined class="border card-info mt-2 mb-4">
              <div class="pa-4">
                <div v-for="(item, index) in basicInfoDevices" :key="index">
                  <LabelValueInfo
                    :label="item.label"
                    :value="item.value"
                    :check="item.check"
                    :br-check="item.brCheck"
                    :is-check-size-small="isDisplaySmall"
                  />
                </div>
              </div>
            </v-card>
            <div class="grid-container">
              <v-col cols="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="numberApartment"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-home-account"
                  label="Номер квартиры"
                  type="number"
                  :rules="[
                    () => !!numberApartment || 'Обязательное поле',
                  ]"
                  :maxlength=64
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0" v-if="typeServices === 'buyKey'">
                <v-text-field
                  v-model="codeKey"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-file-code-outline"
                  label="Код ключа"
                  :rules="[
                    () => !!codeKey || 'Обязательное поле',
                    () => /^[0-9A-F]*$/.test(codeKey) || 'Поле должно содержать цифры и заглавные символы латиницы (A-F)',
                  ]"
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
<!--              <v-col cols="12" sm="6" md="4" lg="3" xl="2" class="pb-0 pt-0" v-if="typeServices !== 'buyPhone'">-->
<!--                <v-text-field-->
<!--                  v-model="countKeys"-->
<!--                  class="mt-0 mb-2 border"-->
<!--                  type="number"-->
<!--                  prepend-inner-icon="mdi-counter"-->
<!--                  label="Количество"-->
<!--                  persistent-hint-->
<!--                  outlined-->
<!--                  hide-details-->
<!--                  dense-->
<!--                />-->
<!--              </v-col>-->
              <v-col cols="12" sm="6" md="4" lg="3" xl="2" class="pb-0 pt-0" v-if="typeServices === 'buyPhone'">
                <v-text-field
                  v-model="phone"
                  class="mt-0 mb-2 border"
                  prepend-inner-icon="mdi-phone"
                  label="Номер телефона"
                  persistent-hint
                  outlined
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0 box-3" v-if="typeServices !== 'callPhone'">
                <v-text-field
                  v-model="fullName"
                  class="mt-0 mb-2 border"
                  type="string"
                  label="ФИО"
                  prepend-inner-icon="mdi-rename-outline"
                  persistent-hint
                  outlined
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0" v-if="typeServices === 'buyPhone'">
                <v-autocomplete
                  v-model="selectedTypeDevice"
                  class="border"
                  item-value="id"
                  item-text="value"
                  prepend-inner-icon="mdi-cog-outline"
                  placeholder="Устройства"
                  outlined
                  dense
                  hide-details
                  persistent-hint
                ></v-autocomplete>
              </v-col>
            </div>
            <v-card outlined class="border card-info card-completion mt-2 mb-2" v-if="typeServices !== 'codeDoor' && typeServices !== 'callPhone'">
              <div style="padding: 22px;">
                <p v-if="priceKey" style="font-size: 18px">Стоимость одного ключа: {{ priceKey }} руб.</p>
                <p v-if="intercomCost" style="font-size: 18px">Стоимость переговорного устройства: {{ intercomCost }} руб.</p>
                <p v-if="connectionCost" style="font-size: 18px">Стоимость подключения: {{ connectionCost }} руб.</p>
<!--                <p style="font-size: 18px">Итого к оплате: {{ totalPayable }} руб.</p>-->
              </div>
              <v-spacer></v-spacer>
              <div v-if="typeServices === 'buyKey'">
                <v-btn
                  color="primary"
                  outlined
                  class="text-none ma-4 px-2"
                  rounded
                  @click.prevent="readKey()"
                >
                  Считать код ключа
                </v-btn>
              </div>
            </v-card>
          </v-row>
        </v-container>
        <div style="display: block; text-align: center;">
          <v-btn
            outlined
            class="text-none mt-3 px-2 btn-completion"
            rounded
            @click="save"
          >
            Завершить оформление
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents" v-if="isCellar">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify">
              <p class="text-info">
                Документы необходимые от клиента: паспорт, а также
                один из нижеперечисленных документов:
                <br><br>
                1.Постоянная регистрация по указанному адресу;<br>
                2.Выписка из ЕГРН или договор долевого участия +
                акт приёма передачи или расписка Росреестра в получении
                документов на регистрацию права собственности;<br>
                3.Нотариально заверенная доверенность от собственника,
                если заключает договор или получает ключи не собственник.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import LabelValueInfo from '@/components/LabelValueInfo';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LabelValueInfo },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    typeServices: String,
    header: String,
    icon: String,
    message: String,
    isCellar: Boolean,
    intercomCost: Number,
    priceKey: String,
    connectionCost: Number,
    attPopupDoorphoneContent: {
      type: Object,
    },
    basicInfoDevices: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    countKeys: null,
    numberApartment: null,
    fullName: '',
    phone: '',
    selectedTypeDevice: 0,
    totalPayable: 0,
    selectedType: 0,
    codeKey: '',
    comment: '',
    internal_reader: ['1'],
    external_reader: ['2'],
    keyDuplicate: true,
    isDisplaySmall: false,
    typeKey: [
      { id: 0, value: 'Неуниверсальный' },
      { id: 1, value: 'Универсальный' },
    ],
  }),
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      role: 'role',
    }),
    displayDuplicate () {
      return (this.attPopupDoorphoneContent.type === 'M') &&
        ((this.attPopupDoorphoneContent.additionalEntrances.length > 0) ||
          (this.attPopupDoorphoneContent.gates.length > 0));
    },
  },
  methods: {
    ...mapActions({
      updateManagementGroup: 'GroupManagementCompany/updateManagementGroup',
      toReadKey: 'Keys/readKey',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    readKey () {
      this.toReadKey()
        .then((response) => {
          if (response) {
            this.codeKey = response.data;
          } else {
            this.$flash_warning('Поднесите ключ к считывателю');
          }
        })
        .catch(e => {
          this.$flash_warning('Проверьте подключение к считывателю');
          console.error(e);
        });
    },
    async save () {
      // this.$refs.form.validate();
      this.$nextTick(async () => {
        if (this.valid) {
          if (this.typeServices === 'buyKey') {
            if (this.codeKey === '' || this.numberApartment === null) {
              this.$flash_danger('Заполните форму');
              return;
            }
          }
          await this.$emit(
            'complete', this.numberApartment, this.codeKey, this.selectedType, this.keyDuplicate, this.fullName,
            this.internal_reader, this.external_reader,
          );
        }
      });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-title-reader {
  display: block;
  text-align: center;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(172, 204, 172, 0.5);
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 97.34px;
  max-height: 97.34px;
  text-align: center;
  background-color: #85B285;
}
.custom-icon {
  font-size: 48px;
  height: 100%;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  box-shadow: none;
  background-color: rgba(172, 204, 172, 0.5);
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 2 / 3;
}
.box-5 {
  grid-column: 1 / 3;
  grid-row: 3 / 4;
}
.btn-completion {
  width: 100%;
  max-width: 250px;
  background-color: #85B285;
  color: white;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .grid-container {
    display: block;
  }
  .card-title-reader {
    font-size: 16px;
    white-space: nowrap;
    padding: 11px;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
</style>
